import classNames from "classnames";
import {FiAlertTriangle, FiCheck} from "react-icons/fi";

import {AssistantIcon} from "@/components/assistant/AssistantIcon.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {AnalyzerRevisionNoticeProps} from "@/pages/analyzer/Analyzer.types.ts";

import styles from "./AnalyzerRevisionNotice.module.scss";

export const AnalyzerRevisionNotice = ({success, callout, body, className}: AnalyzerRevisionNoticeProps) => (
  <div className={classNames(styles.notice, className)}>
    <AssistantIcon size="small" className={styles.avatar} />
    <div className={styles.bubble}>
      <Icon
        icon={success ? FiCheck : FiAlertTriangle}
        size="normal"
        removeDivDimensions
        className={classNames(styles.icon, success ? styles.success : styles.warning)}
      />
      <div className={styles.text}>
        <span className={styles.callout}>{callout}</span> — {body}
      </div>
    </div>
  </div>
);
